import { jsx as _jsx } from "react/jsx-runtime";
import { useLanguageContext } from './LanguageContext';
import styles from './FormError.module.css';
export const FormError = ({ id, error, inputId }) => {
    const { i18n } = useLanguageContext();
    return error ? (_jsx("div", { role: "alert", id: id, className: styles.error, "data-test-id": `error-${inputId}`, children: i18n.translate(error) })) : null;
};
